import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/system'
import { cx } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import SocialLogin from '../../../../organisms/social-login/social-login'
import DynamicAreas from '../../../../particles/dynamic-areas'
import RegisterForm from './register-form'
import { Root, SubTitle, Title } from './register.styled'

const Register = ({ className, dynamicAreas }) => {
	const theme = useTheme()
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'))

	return (
		<Root className={cx('RegisterForm-root', className)}>
			<DynamicAreas areas={dynamicAreas} container="top" />

			<Title component="h1" variant={lgUp ? 'h4' : 'h1'}>
				<FormattedMessage id="register_title" />
			</Title>
			<SubTitle variant="body1">
				<FormattedMessage id="register_subtitle" />
			</SubTitle>

			<DynamicAreas areas={dynamicAreas} container="middle" />

			<RegisterForm source="Register" />
			<SocialLogin />

			<DynamicAreas areas={dynamicAreas} container="bottom" />
		</Root>
	)
}

export default Register
